import { isDevEnv } from "./features";

const logToConsole = (
  type: "log" | "error" | "warn" | "debug" | "info",
  ...args: unknown[]
) => {
  const shouldPrint =
    isDevEnv || sessionStorage.getItem("LOG_LEVEL") === "debug";
  if (!shouldPrint) return;

  // eslint-disable-next-line no-console
  console[type](...args);
};

export const log = (...args: unknown[]) => {
  logToConsole("log", ...args);
};

export const error = (...args: unknown[]) => {
  logToConsole("error", ...args);
};

export const warn = (...args: unknown[]) => {
  logToConsole("warn", ...args);
};

export const debug = (...args: unknown[]) => {
  logToConsole("debug", ...args);
};

export const info = (...args: unknown[]) => {
  logToConsole("info", ...args);
};
